module.exports = __webpack_public_path__ + "statics/img/Nullcang.a33e311d.png";